import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, take, tap, throwError } from 'rxjs';
import { BaseResponse } from '../../models/response/base-response';
import { LoginResponse } from '../../models/response/login-response';
import { AvisoService } from '../../service/aviso/aviso.service';
import { BaseApi } from '../base-api';
import { LoginRequest } from '../../models/request/login-request';
import { LoginComPerfilRequest } from '../../models/request/login-com-perfil-request';

@Injectable({
  providedIn: 'root',
})
export class AutenticacaoService extends BaseApi {
  private readonly AvisoService = inject(AvisoService);

  private static readonly autenticado$ = new BehaviorSubject<boolean>(false);
  private static readonly sessaoUsuario$: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);
  public static readonly usuario$ = AutenticacaoService.sessaoUsuario$.asObservable();

  controller = 'Autenticacao/';

  Login(model: LoginRequest) {
    return this.postJson<BaseResponse<LoginResponse>>(this.controller + 'Login', model).pipe(
      take(1),
      catchError((e) => {
        this.AvisoService.Erro(e);
        return throwError(() => e);
      }),
      tap((u) => this.setarToken(u)),
    );
  }

  LoginComPerfil(model: LoginComPerfilRequest) {
    return this.postJson<BaseResponse<LoginResponse>>(this.controller + 'LoginComPerfil', model).pipe(
      take(1),
      catchError((e) => {
        this.AvisoService.Erro(e);
        return throwError(() => e);
      }),
      tap((u) => this.setarToken(u)),
    );
  }

  Logout() {
    ['usuarioId', 'grupoId', 'perfil', 'vencimentoSessao', 'nivelDeAcesso', 'nome', 'usuario', 'email', 'telefone', 'token']
      .forEach((key) => localStorage.removeItem(key));

    AutenticacaoService.autenticado$.next(false);
    AutenticacaoService.sessaoUsuario$.next(null);
  }

  setarToken(reponse: BaseResponse<LoginResponse>) {
    if (reponse.status) {
      if (reponse.resultado.logado) {
        AutenticacaoService.sessaoUsuario$.next(reponse.resultado);

        const sessao = reponse.resultado.sessaoUsuario;

        localStorage.setItem('usuarioId', sessao?.usuarioId?.toString() ?? '');
        localStorage.setItem('grupoId', sessao?.grupoId?.toString() ?? '');
        localStorage.setItem('perfil', sessao?.perfil ?? '');
        localStorage.setItem('vencimentoSessao', sessao?.vencimentoSessao ?? '');
        localStorage.setItem('nivelDeAcesso', sessao?.nivelDeAcesso?.toString() ?? '');
        localStorage.setItem('usuario', sessao?.usuario ?? '');
        localStorage.setItem('nome', sessao?.nome ?? '');
        localStorage.setItem('email', sessao?.email ?? '');
        localStorage.setItem('telefone', sessao?.telefone ?? '');
        localStorage.setItem('token', reponse.resultado.token);

        AutenticacaoService.autenticado$.next(true);
      } else {
        localStorage.setItem('token', reponse.resultado.token);
      }
    }
  }
}
